import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import { useGroupFilters } from '@app/group/hooks/use-group-filters';
import { usePeriodDateRange } from '@app/group/hooks/use-period-date-range';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetGroupCompanyReports } from '@shared/api/hooks/group/company-reports';
import { GroupCompanyReportsListSortItem } from '@shared/api/types';
import GroupPage from '../components/group-page';
import GroupCompanyReportsTable from '../components/tables/group-company-reports-table';

export default function GroupCompanyReportsPage() {
  const { page, perPage, sort } = useDataTableQueryState();
  const [{ orgs }] = useGroupFilters();
  const { start, end } = usePeriodDateRange();

  const data = useGetGroupCompanyReports({
    page,
    page_size: perPage,
    sort: formatMultipleSortingForEndpoint(
      sort ?? []
    ) as GroupCompanyReportsListSortItem[],
    organizations: orgs.length ? orgs : undefined,
    dateStart: start ?? undefined,
    dateEnd: end ?? undefined,
  });

  const count = data.data?.count ?? 0;
  const pageCount = Math.ceil(count / (perPage || 10));

  if (data.isError) throw new Error('Failed to load group company reports');

  return (
    <GroupPage pageKey="companyReports">
      <GroupCompanyReportsTable {...data} pageCount={pageCount} />
    </GroupPage>
  );
}
